import apiClient from './apiClient';

const cmsService = {
  // Get How It Works page
  getHowItWorks: async () => {
    return apiClient.get('/cms/how-it-works');
  },

  // Get How It Works 2 page
  getHowItWorks2: async () => {
    return apiClient.get('/cms/how-it-works2');
  },

  // Get What We Do page
  getWhatWeDo: async () => {
    return apiClient.get('/cms/what-we-do');
  },

  // Get Who We Are page
  getWhoWeAre: async () => {
    return apiClient.get('/cms/who-we-are');
  },

  // Get Ways to Fly page
  getWaysToFly: async () => {
    return apiClient.get('/cms/ways-to-fly');
  },

  // Get FAQ page
  getFAQ: async () => {
    return apiClient.get('/cms/faq');
  },

  // Get Safety and Security page
  getSafetyAndSecurity: async () => {
    return apiClient.get('/cms/safety-and-security');
  },

  // Get News page
  getNews: async () => {
    return apiClient.get('/cms/news');
  },

  // Get Blog listing
  getBlogs: async () => {
    return apiClient.get('/cms/blog');
  },

  // Get single blog post
  getBlogPost: async (slug) => {
    return apiClient.get(`/cms/blogs/${slug}`);
  },

  // Get About Us page
  getAboutUs: async () => {
    return apiClient.get('/cms/about-us');
  },

  // Get Contact Us page
  getContactUs: async () => {
    return apiClient.get('/cms/contact-us');
  },

  // Submit contact form
  submitContactForm: async (formData) => {
    return apiClient.post('/cms/contact', formData);
  },

  // Get Investor Relations page
  getInvestorRelations: async () => {
    return apiClient.get('/cms/investor-relations');
  },

  // Get Career page
  getCareer: async () => {
    return apiClient.get('/cms/career');
  },

  // Get Terms and Conditions page
  getTermsAndConditions: async () => {
    return apiClient.get('/cms/terms-and-conditions');
  },

  // Get Privacy Policy page
  getPrivacyPolicy: async () => {
    return apiClient.get('/cms/privacy-policy');
  },

  // Get Cookie Policy page
  getCookiePolicy: async () => {
    return apiClient.get('/cms/cookie-policy');
  },

  // Get Refund and Cancellation page
  getRefundAndCancellation: async () => {
    return apiClient.get('/cms/refund-and-cancellation');
  },

  // Get Offer Terms page
  getOfferTerms: async () => {
    return apiClient.get('/cms/offer-terms');
  },

  // Get all pages (admin)
  getAllPages: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    if (params.sort_order) queryParams.append('sort_order', params.sort_order);
    
    const queryString = queryParams.toString();
    const url = queryString ? `/cms/pages?${queryString}` : '/cms/pages';
    return apiClient.get(url);
  },

  // Newsletter subscription
  subscribeNewsletter: async (email) => {
    return apiClient.post('/cms/newsletter/subscribe', { email });
  }
};

export default cmsService;
